import { render } from "./Transportador.vue?vue&type=template&id=90e9a9cc"
import script from "./Transportador.vue?vue&type=script&lang=ts"
export * from "./Transportador.vue?vue&type=script&lang=ts"
script.render = render

export default script